<template>

    <div class="pointOfView">
        <ButtonSound v-if="sound" v-bind="sound"></ButtonSound>
        <div class="pointOfView_image" ref="image">
            <img :src="imgPath(image)"  />
        </div>
        <div class="pointOfView_content">
            <h1 v-html="title"></h1>
            <div v-if="soundTitle" class="pointOfView_content_button-inTitle">
                <ButtonSound class="buttonSound_nolegend" v-if="soundTitle" v-bind="soundTitle"></ButtonSound>
                <h2 class="appearEffect" v-html="subTitle"></h2>
            </div>
            <h2 v-else="soundTitle" class="appearEffect" v-html="subTitle"></h2>
            <p v-html="author" class="appearEffect author"></p>
            <div v-if="authorQuote" v-html="authorQuote" class="appearEffect pointOfView_content_quote"></div>
            <div class="appearEffect pointOfView_content_desktop">
                <slot></slot>
            </div>
        </div>

        <div class="pointOfView_content_mobile boxed">
            <slot></slot>
        </div>

    </div>

</template>

<script>
    import Scrolldown from "./Scrolldown";
    import ButtonSound from "./ButtonSound";
    export default {
        name: 'PointOfView',
        components: {ButtonSound},
        props: {
            title: {
                type: String,
                default: '',
            },
            subTitle: {
                type: String,
                default: '',
            },
            author: {
                type: String,
                default: '',
            },
            authorQuote: {
                type: String,
                default: '',
            },
            image: {
                type: String,
                default: '',
            },
            sound: {
                type: Object
            },
            soundTitle: {
                type: Object
            },
        },
        methods: {
            imgPath: function(image){
                return require('../assets/img/'+image);
            },
        },
    };
</script>

<style scoped lang="scss">
    .pointOfView{


        @include breakpoint(xs){
            padding-top: 15rem;
        }
        &_image{
            position: fixed;
            left: 0;
            top: 0;
            width: calc(20% - 16px);
            height: 100%;
            @include breakpoint(xs){
                width: 30%;
                position: static;
                float: left;
            }
            img{
                object-fit: cover;
                width: 100%;
                height: 100%;
            }
        }

         &_content{
            margin: 0 20% 0 20%;
            padding-left: $G-default*2;

            @include breakpoint(xs){
                float: left;
                width: 70%;
                margin: 0;
                padding-left: $G-default;
            }
            &_desktop{
                display: block;
                @include breakpoint(xs){
                    display: none;
                }
            }
            &_mobile{
                display: none;
                @include breakpoint(xs){
                    display: block;
                    clear: both;
                    padding-top:  $G-default;
                }
            }
            &_quote {
                font-family: $F-Montserrat;
                margin-bottom: $G-default/2;
                font-weight: $FW-light;
                font-size: 3rem;
            }

            &_button {
                &-inTitle {
                    .buttonSound {
                        position: relative;
                        float: left;
                        color: #000;
                        top: 0;
                        left: 0;
                        transform: none;
                        animation: none;

                        &_legend {
                            display:none;
                        }
                    }

                    h2 {
                        line-height: 4.3rem;
                    }
                }
            }
        }
    }
    h1{
        font-weight: $FW-bold;
        font-size: 4rem;
        text-transform: initial;
        margin-top:  9rem;
        margin-bottom: 0;
    }
    h2{
        font-weight: $FW-normal;
        font-size: 1.8rem;
        text-transform: uppercase;
        margin-top: $G-default / 2;
        margin-bottom: $G-default / 2;
        letter-spacing: 0.02em;
    }
    p.author{ 
        margin-bottom:3rem;
        &:empty {
            display: none;
        }
    }
</style>